import { useState } from 'react'
import classNames from 'classnames'
import css from './author_profile.scss'
import { Link, Box } from '@material-ui/core'
import { helloBabyPostPath } from 'lib/urls'
import { InfoButton } from 'components/buttons'

const Post = ({ post }) => {
  return (
    <Link href={helloBabyPostPath(post.slug)} key={`post_${post.slug}`}>
      <Box key={post.slug} className={classNames(css.post)}>
        <h3>{post.title}</h3>
      </Box>
    </Link>
  )
}

function isPrerender() {
  try {
    if (typeof window === 'undefined') {
      return false
    }
    return window?.navigator?.userAgent?.includes(
      'Prerender (+https://github.com/prerender/prerender)'
    )
  } catch (e) {
    return false
  }
}

const Posts = ({ author }) => {
  const prerender = isPrerender()

  let name = `${author.firstName} ${author.lastName}`
  if (!author.firstName && !author.lastName) {
    name = author.name
  }

  const [showPosts, setShowPosts] = useState(false)

  const togglePosts = () => {
    setShowPosts((show) => !show)
  }

  const allPosts = author.featuredPosts.concat(author.posts)
  const posts = prerender || showPosts ? allPosts : allPosts.slice(0, 60)

  return (
    <Box className={classNames(css.postsContainer)}>
      <Box className={classNames(css.posts)}>
        <h2>Articles by {name}</h2>
        <Box className={classNames(css.allPosts)}>
          {posts.map((post) => Post({ post }))}
        </Box>
        {!showPosts && posts.length < allPosts.length && (
          <InfoButton pill onClick={togglePosts}>
            See all by this author
          </InfoButton>
        )}
        {showPosts && (
          <InfoButton pill onClick={togglePosts}>
            Hide
          </InfoButton>
        )}
      </Box>
    </Box>
  )
}

export default Posts
